module.exports = __webpack_public_path__ + "static/img/4product50x59.d8811d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/4product50x59.jpg
// module id = cuGE
// module chunks = 1